import React, { useState, useEffect, Fragment, useRef, createRef } from 'react';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ButtonWithIcon from 'components/sales/buttons/buttonWithIcon/buttonWithIcon';
import FormSection from 'components/sales/formSection/formSection';
import localization from 'assets/localization/localization';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Regex from 'services/utils/regex/Regex';

const GatesForm = ({
  gateTypeList = null,
  typeList,
  leadGates,
  fetchLeadGate,
  handleValue = null,
  leadId,
  title = localization.gateDetails+' (Number Of Gates :'+leadGates.no_of_gate+')',
  inputTitle = localization.tagNo,
  dropdownTitle = localization.gateFeature,
  handleDataFilter = null,
  handleremoveValue = null,
  noTag = false,
}) => {
  const objInput = { current_setup_id: '', gate_no: '' };
  const [inputList, setInputList] = useState([]);
  const [inputListData1, setInputListData1] = useState('');
  const [inputListData2, setInputListData2] = useState('');
  const [inputValue, setInputValue] = useState([objInput]);
  const [isCurrentRef, setIsCurrentRef] = useState(0);
  const [isError, setIsError] = useState(false);
  const [catVal, setCatVal] = useState('');
  const [numberVal, setNumberVal] = useState('');
  const inputRef = useRef([]);

  useEffect(() => {
    if (typeList !== null && typeList !== undefined) {
      if (typeList.length) {
        typeList.map((_, index) => {
          inputRef.current[index] = createRef();
        });
      }
    }
  }, [typeList]);

  const addGates = (event) => {
    // alert(event.target.getAttribute('id'));
    if (noTag === false) {
      if ((!inputListData1.length && !inputListData2.length) || isError) {
        setIsError(true);
        return false;
      }
    } else {
      if (!inputListData1 || isError) {
        setIsError(true);
        return false;
      }
    }

    setInputValue([...inputValue, { current_setup_id: '', gate_no: '' }]);
    if (inputListData1?.id) {
      if (handleDataFilter) {
        handleDataFilter(inputValue);
      }
    }
    if (typeList.length === 0) {
      return false;
    }
    setInputList([...inputList, { id: Math.floor(Math.random() * 100) }]);
    setIsError(false);
    setInputListData1('');
    setInputListData2('');
  };

  const removeGate = (index = null) => {
    setInputListData1({ id: inputValue[index]?.current_setup_id });
    setInputListData2(inputValue[index]?.gate_no);
    let removeArray = inputValue.splice(index + 1, 1);
    inputList.splice(index, 1);
    setInputValue([...inputValue]);
    setInputList([...inputList]);
    if (handleremoveValue) {
      handleremoveValue(removeArray);
    }
  };

  useEffect(() => {
    if (gateTypeList)
      (async () => {
        await gateTypeList();
      })();
  }, []);

  useEffect(() => {
    handleGates();
    if (typeList.length === 1) {
      if (handleDataFilter) {
        handleDataFilter(inputValue);
      }
    }
  }, [inputValue]);

  const handleGates = (value) => {
    if (inputValue && handleValue) {
      for (const obj of inputValue) {
        if (obj.current_setup_id === '') {
          return false;
        }
      }
      if (!leadId) {
        handleValue({
          gates: [...inputValue],
        });
      } else {
        handleValue({
          gates: [...inputValue],
          lead_id: leadId,
        });
      }
    }
  };
  const handleInitalValue = () => {
    setCatVal('None');
    setNumberVal('1');
    setInputValue([objInput]);
    if (handleremoveValue) {
      handleremoveValue([]);
    }
  };
  const handleInputValue = (val, key, index) => {
    const list = [...inputValue];
    list[index][key] = val;
    setInputValue([...list]);
  };
// alert(leadGates.no_of_gate);
  let count = leadGates.no_of_gate;
  // console.log(count);
    useEffect(() => {
      if(document.getElementById('addMore')){
       
        setInputValue([...inputValue, { current_setup_id: '', gate_no: '' }]);
        if (inputListData1?.id) {
          if (handleDataFilter) {
            handleDataFilter(inputValue);
          }
        }
        if (typeList.length === 0) {
          return false;
        }
        setInputList([...inputList, { id: Math.floor(Math.random() * 100) }]);
        setIsError(false);
        setInputListData1('');
        setInputListData2('');
        
      }
    }, [count]); // Good!
  
 
  
  return (
    <Fragment>
      <FormSection title={title}>
        <div className="w-100 row mx-0">
          <div
            ref={inputRef.current[0]}
            className="row mx-0"
            disabled={catVal && numberVal ? true : false}
          >
            
            
            <DropDownInput
                label={dropdownTitle}
                data={typeList}
                id={typeList.id}
                getIdValue={(val) => {
                  setCatVal(val.value);
                  setInputListData1(val);
                  setIsCurrentRef(0);
                  handleInputValue(val.id, 'current_setup_id', 0);
                }}
                errorMsg={localization.isRequired}
                required
                isStarRequired={true}
                value={catVal}
              />

            {noTag === false ? (
              <ConstantInput
                label={inputTitle}
                name="gate_no"
                errorMsg={localization.numberError}
                type="number"
                handleChange={(val) => {
                  // setNumberVal(val);
                  setInputListData2(val);
                  setIsCurrentRef(0);
                  handleInputValue(val, 'gate_no', 0);
                  setIsError(
                    !Regex.numericNotZero.test(inputValue[0]?.gate_no)
                  );
                }}
                value={numberVal}
                required
                isStarRequired={true}
                min={0}
                regex={Regex.numericNotZero.test(inputValue[0]?.gate_no)}
              />
            ) : null}
          </div>
          <div>
            {inputList.length === 0 && catVal && numberVal ? (
              <Fragment>
                <ButtonWithIcon
                  onClick={handleInitalValue}
                  title={localization.clear}
                />
              </Fragment>
            ) : null}
          </div>
        </div>

        {inputList &&
          inputList.map((item, index) => {
            return (
              <div key={item.id} className="w-100 row mx-0">
                <div className="row mx-0" ref={inputRef.current[index + 1]}>
                  <DropDownInput
                    label={dropdownTitle}
                    data={typeList}
                    id={typeList.id}
                    getIdValue={(val) => {
                      setInputListData1(val);
                      setIsCurrentRef(index + 1);
                      handleInputValue(val.id, 'current_setup_id', index + 1);
                    }}
                    errorMsg={localization.isRequired}
                    required
                    isStarRequired={true}
                  />
                  {noTag === false ? (
                    <ConstantInput
                      label={inputTitle}
                      errorMsg={localization.numberError}
                      type="number"
                      handleChange={(val) => {
                        setInputListData2(val);
                        setIsCurrentRef(index + 1);
                        handleInputValue(val, 'gate_no', index + 1);
                        setIsError(
                          !Regex.numericNotZero.test(
                            inputValue[index + 1]?.gate_no
                          )
                        );
                      }}
                      min={0}
                      regex={Regex.numericNotZero.test(
                        inputValue[index + 1]?.gate_no
                      )}
                    />
                  ) : null}
                </div>
                <div>
                  <button
                    style={{ border: 'transparent' }}
                    className="field-remove"
                    onClick={() => removeGate(index)}
                  >
                    {localization.remove}
                  </button>
                </div>
              </div>
            );
          })}
        <span>
          {isError ? (
            <label className="error d-block">{localization.enterField}</label>
          ) : null}
        </span>
        <div className="w-100 mb-20">
          {typeList.length !== 0 && (
            <ButtonWithIcon
              title={localization.addMoreGates}
              id={`addMore`}
              onClick={addGates}
              disabled={isError}
            />
          )}
        </div>
      </FormSection>
    </Fragment>
  );
};

export default GatesForm;
